export const actualItineraryPathSegmentSelector = ({actualItineraryPathSegment}) => actualItineraryPathSegment